import { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import './index.scss';
import Spinner from "../../Components/Spinner";
import api from "../../Components/Api/Api";

const Retorna_orcamento = () => {
    const navigate = useNavigate(); 
    const [cadok, setCadok] = useState(false)
    const [orcamento, setOrcamento] = useState('')
    const [ShowLoading, setShowLoading] = useState(false)
    const credentials = btoa("RestAPI:siga@181"); 
    const headers = {
        'Content-Type': 'application/json;charset=UTF-8',
        "Access-Control-Allow-Origin": "*",
        "User-Agent": "PneusBrasil",
        "Accept": "application/json",
        'Authorization': `Basic ${credentials}`
    }   
    const handleOS = (e: any) => {
        setOrcamento(e.target.value)        
    }; 
    const handlingenviar = (e: any) =>{
        setShowLoading(true)
        if((orcamento ) === ''){
            alert('Preencher os campo numero da OS!')
            setShowLoading(false)
            return
        }        
        const url = 'ReativarOS';
        // const headers = {
        //     'Content-Type': 'application/json;charset=UTF-8',
        //     "Access-Control-Allow-Origin": "*",
        //     "User-Agente": "PneusBrasil",
        //     "Accept": "*/*",
        //   }         
        const data = {
            'Empresa':"01",
            'Filial':"01",
            'Z9_NUM': orcamento,            
        }
        api.post(url,data, {headers})
        .then(function (response) {
            if(response.data['info'] === 'erro'){
                setShowLoading(false)
                alert('Erro na alteração! da OS: '+ response.data['codigo'])
            }  
            if(response.data['info'] === 'alterdo'){
                setShowLoading(false)
                alert('OS retornada com sucesso, OS: '+ response.data['codigo'])
                navigate('/entrada')
            }                                  
        })
        .catch(function (error: any) {
            console.error(error);
            setShowLoading(false)
            alert('Alert: Erro de conexão com servidor! ')
        });                        
    }

    useEffect(() => {
        if(cadok) { 
            navigate('/home')
        }
                           
    })
    return (
        <>
            <Container>
                <div>
                    <span className="d-flex justify-content-center fs-3 text-primary">Reativar OS</span>
                </div> 
                <div>
                    <label className="mx-auto d-block">Numero da OS </label>
                    <input onChange={(e) => handleOS(e)}></input>
                    <button className="btn btn-primary celular" onClick={() => {setCadok(true)}}>Sair</button>
                    <button className="btn btn-success celular" onClick={(e) => handlingenviar(e)}>Reativar</button>
                </div>               

            </Container>
            <Spinner isLoading={ShowLoading} /> 
        </>
    )
};

export default Retorna_orcamento;